module.exports = __webpack_public_path__ + "static/media/logo.c571326a.svg";